module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-006"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("3:1-17 ISRAEL CROSSES THE JORDAN")])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Then Joshua rose early in the morning and they set out from Shittim. And they came to the Jordan, he and all the people of Israel, and lodged there before they passed over. "), _c('sup', [_vm._v("2")]), _vm._v("At the end of three days the officers went through the camp "), _c('sup', [_vm._v("3")]), _vm._v("and commanded the people, “As soon as you see the ark of the covenant of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God being carried by the Levitical priests, then you shall set out from your place and follow it. "), _c('sup', [_vm._v("4")]), _vm._v("Yet there shall be a distance between you and it, about 2,000 cubits"), _c('a', {
    staticClass: "apnb",
    attrs: {
      "epub:type": "noteref",
      "href": "#/p1chap7#ntb-006",
      "id": "ap_ntb-006-1"
    }
  }, [_vm._v("a")]), _vm._v(" in length. Do not come near it, in order that you may know the way you shall go, for you have not passed this way before.” "), _c('sup', [_vm._v("5")]), _vm._v("Then Joshua said to the people, “Consecrate yourselves, for tomorrow the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" will do wonders among you.” "), _c('sup', [_vm._v("6")]), _vm._v("And Joshua said to the priests, “Take up the ark of the covenant and pass on before the people.” So they took up the ark of the covenant and went before the people.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_c('sup', [_vm._v("7")]), _vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Joshua, “Today I will begin to exalt you in the sight of all Israel, that they may know that, as I was with Moses, so I will be with you. "), _c('sup', [_vm._v("8")]), _vm._v("And as for you, command the priests who bear the ark of the covenant, ‘When you come to the brink of the waters of the Jordan, you shall stand still in the Jordan.’” "), _c('sup', [_vm._v("9")]), _vm._v("And Joshua said to the people of Israel, “Come here and listen to the words of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God.” "), _c('sup', [_vm._v("10")]), _vm._v("And Joshua said, “Here is how you shall know that the living God is among you and that he will without fail drive out from before you the Canaanites, the Hittites, the Hivites, the Perizzites, the Girgashites, the Amorites, and the Jebusites. "), _c('sup', [_vm._v("11")]), _vm._v("Behold, the ark of the covenant of the Lord of all the earth"), _c('a', {
    staticClass: "apnb",
    attrs: {
      "epub:type": "noteref",
      "href": "#/p1chap7#ntb-007",
      "id": "ap_ntb-007-1"
    }
  }, [_vm._v("b")]), _vm._v(" is passing over before you into the Jordan. "), _c('sup', [_vm._v("12")]), _vm._v("Now therefore take twelve men from the tribes of Israel, from each tribe a man. "), _c('sup', [_vm._v("13")]), _vm._v("And when the soles of the feet of the priests bearing the ark of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", the Lord of all the earth, shall rest in the waters of the Jordan, the waters of the Jordan shall be cut off from flowing, and the waters coming down from above shall stand in one heap.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_c('sup', [_vm._v("14")]), _vm._v("So when the people set out from their tents to pass over the Jordan with the priests bearing the ark of the covenant before the people, "), _c('sup', [_vm._v("15")]), _vm._v("and as soon as those bearing the ark had come as far as the Jordan, and the feet of the priests bearing the ark were dipped in the brink of the water (now the Jordan overflows all its banks throughout the time of harvest), "), _c('sup', [_vm._v("16")]), _vm._v("the waters coming down from above stood and rose up in a heap very far away, at Adam, the city that is beside Zarethan, and those flowing down toward the Sea of the Arabah, the Salt Sea, were completely cut off. And the people passed over opposite Jericho. "), _c('sup', [_vm._v("17")]), _vm._v("Now the priests bearing the ark of the covenant of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" stood firmly on dry ground in the midst of the Jordan, and all Israel was passing over on dry ground until all the nation finished passing over the Jordan.")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v(" The significance of the ark of the covenant in the crossing of the Jordan is a major focus of interest in Reformation commentary on this passage. The fact that it goes before all is noted by several commentators, who point to the same role played by the pillars of cloud and fire in the exodus and wilderness wanderings. That the ark is the presence of the Lord is emphasized by the distance from it that the people are to maintain. Yet the ark is also regarded as a type of Jesus Christ, with whom believers are united, and the crossing of the Jordan is regarded as a type of baptism by which believers are united with Christ, passing from death to eternal life. The dangers faced by all in this crossing are not to be minimized and underscore that the path of the life of faith is not an easy one to tread, but one of trials that we share with Christ.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-030"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("3:1-6 "), _c('i', [_vm._v("The People Are Made Ready")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTION OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRONOLOGY")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJETAN:")]), _vm._v(" It is not said that this happened in the morning immediately following [the sending of the spies] . . . but the author of the book returns here to proceed with the history of the execution of the divine command. For he narrates that God commanded Joshua to rise up and cross the Jordan; he narrates also the commencement of two things: the calling of the Reubenites and the admonishing of the people to prepare themselves to cross the Jordan in three days. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-226",
      "id": "ap_ntf-226-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOTHER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING THE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN?")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" It must necessarily be acknowledged that before the spies returned unto him, he had given that charge to the Israelites by the officers, of which mention was made before in Joshua 1:11, namely, that they should prepare themselves provisions because within three days they should pass over the Jordan. That charge was certainly given to them at Shittim (it could not be given them when they came to the Jordan, where they lodged only one night, as it is said here, and then passed over the next day) and must therefore have been given to them before the spies came back, if we understand that Joshua went away from Shittim the very next morning after their return. But now, because it is very unlikely that Joshua would appoint the people to prepare to pass over the Jordan within three days when as yet he could not tell whether the spies would return within that time or not, neither was there any point in sending the spies if he had not resolved to wait for their return, so that according to the information they should give him the Israelites might order their journey. I therefore understand that the drift of these words is only to show that when they removed from Shittim to the Jordan, Joshua rose early in the morning that day, to arrange all things for their intended journey, and not that it was early the next morning after the spies returned. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-227",
      "id": "ap_ntf-227-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OING")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORWARD")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMETHING")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKABLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APPEN")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Joshua now exhorts them to pay no further regard to the obstacles and difficulties, and to attend to the power of God. For although the form of the miracle is not yet explained, yet when the ark of the covenant is brought forward like a banner to guide the way, it was natural to infer that the Lord was preparing something unusual. And while they are kept in suspense, their faith is again proved by a serious trial; for it was an example of rare virtue to give implicit obedience to the command, and thus follow the ark, while they were obviously uninformed as to the result. This, indeed, is the special characteristic of faith, not to inquire curiously what the Lord is to do, nor to dispute subtly as to how that which he declares can possibly be done, but to cast all our anxious cares on his providence, and knowing that his power, on which we may rest, is boundless, to raise our thoughts above the world, and embrace by faith that which we cannot comprehend by reason. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-228",
      "id": "ap_ntf-228-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLARS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOUD AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" By this it appears that the course and order in bearing the ark in the time of Moses was changed by Joshua. For then the pillar of the cloud by day and the fire by night went before the people and guided them in their journeys, and the ark was carried in the midst of the army, as being the safest place; but now the cloud is removed, and the ark as their guide is appointed to go before, and to lead them into the land of promise. This action was (as some think probable) to typify to them that the law and its shadows could not, but the ark of the covenant (which typified Jesus Christ) was able to conduct them into the Promised Land. And as there was no "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("other way of entrance into the earthly Canaan but by following the ark, so there is no other way of entrance into the heavenly Canaan than by Jesus Christ alone. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-229",
      "id": "ap_ntf-229-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" Let us see what is signified to us through these things. For the ark of the covenant points to Christ himself. For in the ark were manna, the rod of Aaron, and the Decalogue, and above the ark was the mercy seat, a place of oracles where God was giving his answers. In Christ is the treasury of all the wisdom and power of God. In Christ is all life. He himself is our mercy seat, who pleased his Father for us, and where our Father speaks with us. For Christ revealed to us the whole counsel of God. And he himself is the book of the living. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:1-8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-230",
      "id": "ap_ntf-230-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" Priests ought to go before the people, preaching virtues with a holy character, which move people more than words. Let them carry the sacred ark of the covenant and the book of the divine law and its teaching on their shoulders. Let them bring it before the people, and by going before them show the way of salvation to the people who will follow. The people ought to look at that ark and follow it, so that they may not stray from the road. To be sure, they ought to look at it not uncovered, but rather veiled. In the era of Moses there was a deadly danger that some Levite would see the ark uncovered. But in the era of our Lord Jesus Christ, the sacraments of the law and of the mysteries are seen more clearly and for our salvation, and the law of love and faith is viewed without a veil. And what previously wrought death now bestows life in Christ and points to the way of salvation, through Jordan’s streams, to our fatherland and the inheritance of the elect. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-231",
      "id": "ap_ntf-231-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERE THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE TO")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLOW THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK AT A")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTANCE?")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" I answer, first, that all expositors agree that this was partly to teach them to fear the Lord their God, of whose presence amongst them the ark was a sign. Second . . . there are some expositors who understand . . . that they were commanded to keep thus far behind the ark to the end that all of them might more easily see the ark when the priests went with it into the river Jordan, and how the waters of the river were divided before them, and so might know the way by which they were to go. But I do not see how their being two thousand cubits behind the ark could be an advantage for seeing this, and not rather a hindrance, unless we suppose that being so far behind the ark they were on the ascent of a hill, which led down to the river Jordan, from whence they might behold how the priests went on with the ark, and entered the river. Better therefore, I consider, these words may be understood thus . . . : that the priests bearing the ark may “discover a sure and safe passage for you through the river, before you come near to enter into it.” Indeed when the river was divided before them, there could be no question of seeing the way they were to go. But as yet God did not make known to them the miracle he meant to work, but held them as it were in suspense, only hinting the danger of this crossing, by commanding this distance between the ark and them, to the end the Lord, present by the ark that went before them, might find out a safe way for them, before they might set a foot in the channel. And thus this foregoing apprehension of the danger of the passage, might make them with even more admiration and thankfulness acknowledge the mercy of the following miracle. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:4")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-232",
      "id": "ap_ntf-232-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST IN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLOW")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" We have wanted to cross the Jordan and enter into the land of Canaan, that is, enter into eternal life through the afflictions of this world; but the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("afflictions are dire and troublesome, just as the Jordan is a deep and unfathomable river. Therefore, what must be done? The priests carry the ark before us; that is, Christ Jesus ought to be proclaimed to us and the gospel about Christ Jesus ought to be announced to us. For he is the leader of our path; he is what dries up the Jordan for us. But the fact that the people were commanded not to draw near to the ark means that no human being is able to grasp exhaustively how great the majesty of the gospel is, what is the length and breadth of Christ. For the apostle Paul says, “For now we see in a mirror dimly, but then face-to-face.” It further means that nobody is able to embrace the gospel with a sufficiently worthy faith or fulfill the law of God with sufficiently righteous works. Thus the weaker someone is in faith, the farther away he follows the ark. And the godless and resolute sinners clearly do not follow at all, but turn back to Egypt. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:1-8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-233",
      "id": "ap_ntf-233-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANCE OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT?")])]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" The people were ordered to keep a distance of a number of steps from the ark for the sake of reverence, fear, and majesty, so that as the ark went before them at a distance, it might show a more certain path for those who were following it. With great reverence the people embraced the word of the Lord and did not deem it worthless or despise it for any reason. But the remark, “You have not passed this way before” is taken in either one of two senses: (1) they would set out without the direction of the pillar that hitherto had always preceded but has now ceased, and that in its place were the priests, by prophecy and the orders of Joshua, their leader, or (2) none of the Israelites had approached that path through the waters of the Jordan. For all those who had been numbered as having passed through the Red Sea had died except Joshua and Caleb. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:4")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-234",
      "id": "ap_ntf-234-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EQUIRES")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REPARATION")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" Then Joshua commanded the people to sanctify themselves, that is, prepare themselves, for the Lord would work miracles the next day. But how did they sanctify or prepare themselves? Each one gathered his possessions together, not as if they would remain there at the Jordan, but as if they were setting out at once. This was the call to preparation, and it is proclaimed to us suddenly at any moment. For we have come through the desert to the Jordan. That is, the day of our death threatens us at every moment. Therefore, we ought to sanctify and prepare ourselves. How? Let us look in faith to our leader, Jesus Christ, and let us think that a place remains and has been left for us in this world. However, whoever thinks that they will soon set out for another world certainly takes care to obey the divine call, so as not to be drowned in the middle of the Jordan. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:1-8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-235",
      "id": "ap_ntf-235-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAVERY OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" Only as he had been ordered by the Lord, Joshua arranged for the things that had to be done. He commanded the priests to carry the ark so that they, leading with the ark of the covenant and full of faith as an example to the people, might show the way to the people who were relying on them and following them, and prepare them for what was to come. The priests were the first to face the danger of drowning and to face the experience of divine majesty, and they proclaimed and showed the strength of their faith by their deeds. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:4")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-236",
      "id": "ap_ntf-236-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PECIFY THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDER TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERFORMED")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" In order that the Israelites might depend on the mere counsel of God, Joshua does not yet plainly point out the special nature of the miracle, unless, indeed, we choose to read what follows shortly after as forming part of one context. Herein lies the true test of faith, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("to lean on the counsel of God, as not to keep inquiring too anxiously concerning the mode of action or the event. As the word "), _c('i', [_vm._v("qdš")]), _vm._v(" means sometimes “to prepare,” and sometimes “to sanctify,” and either meaning is not inappropriate, I thought it best to leave a free choice. For faith prepares us to perceive the operation of God; and in those times, when God manifested himself to men more nearly, they consecrated themselves by a solemn rite. Thus we see how Moses, on the promulgation of the law, sanctified the people as God had commanded. The view taken by some expositors, that the people were thus commanded to purge themselves from defilements, merely in order that nothing might impede the passage of the Jordan, seems to be too confined. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-237",
      "id": "ap_ntf-237-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE AS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHERS OF THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" Joshua commands the priests to go before the people carrying the ark. We have stated that the ark was a type of Christ. All the teachers of the church are signified by the priests, whose duty it is to set Christ before the people in his deeds and works. They are not to set before them their own dreams nor human traditions, nor their silly sophistries. They ought to be guides to the path, not those who lead others away from it. In order to portray these things, the ancients painted on the walls of their temple an image of Christopher."), _c('sup', [_vm._v("†")]), _vm._v(" This image, according to Philipp Melanchthon in his "), _c('i', [_vm._v("Rhetoric")]), _vm._v(", signifies the teacher of the church. His body is of large stature; he carries Christ through the sea and the midst of the waves. For a teacher of the gospel must have great strength of soul and must undergo countless dangers. The child whom he carries is small but nevertheless that giant complains that he is sinking down under its unexpected weight. For the ministers of the church labor and often do not seem to be helped by Christ and so are almost driven to despair. Meanwhile, that Christopher raises himself up, and steadies his step by a particular tree; that is, the righteous raise and strengthen themselves by the word of God. At first that tree was barren but then begins to blossom. For the teaching of the Word of God, no matter how useless and sterile it seems, still bears fruit in its own time. The old man goes along the shore with a lamp. This of course is a reference to the Word of God. In his satchel he carries fish and bread, for never amid the ingratitude of the world will the righteous lack for food. . . . The priests fulfill their commands, and teach us the obedience that is most required in war. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 14 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-238",
      "id": "ap_ntf-238-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE AND A")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT")]), _vm._v(".")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKTORIN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRIGEL:")]), _vm._v(" The ark of the covenant is an image of the Word of God, of which it is said, “Your Word is a lamp unto my feet and a light unto my path,” that is, a light for the doctrine of God in morals and counsels. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHOLIA ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-239",
      "id": "ap_ntf-239-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-031"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("3:7-13 "), _c('i', [_vm._v("The Lord’s Directions to Joshua, Joshua’s Instructions to the People")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPOLOGICAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADING OF THE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN")]), _vm._v(".")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKTORIN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRIGEL:")]), _vm._v(" Just as Joshua son of Nun, with the miracle at the Jordan, became known to be a man beloved by God, so our Jesus, after going to the Jordan and undergoing baptism by John, began to work miracles and teach doctrine. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHOLIA ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-240",
      "id": "ap_ntf-240-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XALT")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA AS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADER")]), _vm._v(".")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTCH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" That is, I will raise you in reputation and esteem by this miracle that I will do, whereby the people of Israel shall know that I have made you the head over them, and that by your ministry I will bring them into the land of Canaan. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-241",
      "id": "ap_ntf-241-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA’S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORITY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFIRMED")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" Now as to the fact that Joshua was told, “This day I will begin to exalt you in the sight of all Israel, . . .” his authority was confirmed by a miracle. In the same way also the authority of Jesus Christ was confirmed before the whole world through the miracles he performed, and most mightily through his resurrection. For that reason we can safely follow him as our leader, for he will lead us through the afflictions of this world into eternal life. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-242",
      "id": "ap_ntf-242-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRACLE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTIFIES TO")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLING")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" By a mighty miracle, which could not have happened except by divine power, it became clear to the people of Israel that Joshua would indeed be a servant of the Lord and a most mighty prophet, for whom none of the things that the Lord had decreed he would do through him would be difficult, no less than through Moses. In the same way our Lord Jesus Christ was exalted . . . in the mystery of baptism. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-243",
      "id": "ap_ntf-243-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPES")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" The priests who were carrying the ark of the Lord signify the apostles and churchmen who proclaim the gospel about Jesus Christ, since they themselves enter the Jordan by their preaching; that is, they preach the gospel in this age and in this turbulent world. Then the waters of the Jordan, that is, afflictions, retreat so that the people may pass through. But when the priests exit, the waters return, for where there is no preaching of the gospel, there is every calamity and there is no way for people to escape drowning. Therefore, let us hold fast to the gospel so that we may pass through the Jordan. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-244",
      "id": "ap_ntf-244-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TILL AT THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINK OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" That is, when you have passed over Jordan, and have come to the brink of it on the other side, then stand still there until I call you from thence, seeing that by stopping the advance of ark there the course of the waters shall be stopped, until all the people have passed over. For so I understand the meaning of the brink of the river on the farther side, seeing that otherwise the priests with the ark could not in that distance have gone before the people, as was commanded, but before they were passed over the people would have gone before it, and so lost their guidance in securing their passage in the greatest part of it. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-245",
      "id": "ap_ntf-245-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTHER")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHED THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINK OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN?")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" This command to stand still is meant only of a short stop the priests were to make when they first set foot into the waters of Jordan (which had at that time overflowed the banks), namely, until the Lord had miraculously divided the waters and opened a fair passage for them and the people to go through. Once that was done, the priests immediately went forward with the ark on their shoulders into the midst of Jordan. And then indeed they stood still there till all the people were gone over, as it is afterwards stated in verse 17. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-246",
      "id": "ap_ntf-246-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TOPS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIVE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEMIES OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Joshua makes the power of the miracle extend further than just to the entrance of the land, and deservedly; for merely to open up a passage into a hostile territory, from which there was afterward no retreat, would have been nothing else than exposure to death. For either entangled in difficulties, and in an unknown region, they would easily have been destroyed; or they would have perished, worn out by hunger and the absolute want of all things. Joshua therefore declared beforehand, that when God would restore the river to its course, it would just be as if he were stretching forth his hand to rout all the inhabitants of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("land, and that the manifestation of his power given in the passage of the Jordan would be a sure presage of the victory they would obtain over all the nations. . . . He says, hence shall you know that the Lord is present with you . . . not only to plant your feet in the land of Canaan, but also to give you full possession of it. . . . For God does not abandon the work of his hands midway, leaving it maimed and unfinished. When he leads his people to the promised inheritance, he makes a dry passage for them by cutting off the course of the Jordan. How perverse then would it have been for the Israelites to stop short at that momentary act, instead of feeling confident in all time to come, until settled possession of the land were actually obtained! Let us learn then from this example prudently to combine the different acts of divine goodness relating to our final salvation, so that a happy beginning may cherish and keep alive in our minds the hope of an equally happy conclusion. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:10")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-247",
      "id": "ap_ntf-247-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWN TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONG")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEM BY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTS")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" Joshua confirmed the people’s faith in the promises of the Lord, so that hereafter nothing would be difficult for them, since they had been convinced that the Lord, the true and living God, was certainly in their midst and would look out for them concerning all those things, and would not nod off or neglect whatever was necessary for his faithful people. He himself, by his own strength, would drive out all their enemies—those seven nations previously condemned by divine judgment and destined for death—even though their enemies were more numerous, stronger, and more fierce. The reference to these nations is to all the enemies of the faithful who were notorious at that time in the whole world for their enormous cruelty and treachery. Therefore, the just (whom every creature serves) should not fear. To the just it is said, “If you pass through fire, the flame will not burn you. Even the Jordan will turn back and the rock will produce pools of water.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:10")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-248",
      "id": "ap_ntf-248-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALED BY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" When Joshua says that the people will know the presence of God from the miracle, he indirectly scolds them for their distrust, as the mere promise of God ought to have been sufficient for full assurance; and our faith, unless founded solely on this promise, must be continually wavering. But although faith ought properly to rely on the truth of God alone, it does not follow that experimental knowledge may not act as a secondary support to its weakness, and give supplementary aid to its confirmation. For that which God promises to us in word he seals by act, and as often as he exhibits to us public demonstrations of his grace and might, he intends them to be so many confirmations of what he has spoken, and so many helps tending to suppress all our doubts. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:10")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-249",
      "id": "ap_ntf-249-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS A")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERALD OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" The ark carried out the work of a herald, so that people would not admire and worship its craftsmanship so much as adore the Lord of the whole earth and know for certain that the Lord God was always with them, went before them, and would destroy and scatter their enemies. Thus the Israelites should not fear, but be overcome with constant thanksgiving and always revere the ark of the Lord as a pledge of his presence, for he would never be absent from them, but would comfort them from his aid and assistance in good times and in bad. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:10")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-250",
      "id": "ap_ntf-250-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" First, he says that the ark of God will go before; and second, he explains for what purpose, namely, that the Jordan may retire from its place trembling, so to speak, at the presence of the Lord, as is said in the Psalms. . . . At present let us merely understand that while the ark went before, God displayed his power in guiding the people. And in this way there was a confirmation of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("sanctity of the worship appointed by the law, when the Israelites perceived that it was no empty symbol of his presence that God had deposited with them. For the Jordan was compelled to obey God just as if it had beheld his majesty. Let us however remember that the only reason that induced the Lord to display his grace in the ark was because he had placed the tables of his covenant within it. Moreover, as the thing could not be easily believed, Joshua directs the mind of the people to the contemplation of the divine power, which overcomes all difficulties. The title of Ruler of the whole earth here applied to God is not insignificant, but extols his power above all the elements of nature, in order that the Israelites, considering how seas and rivers are subject to his dominion, might have no doubt that the waters, though naturally liquid, would become stable in obedience to his word. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-251",
      "id": "ap_ntf-251-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVENANT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERHARD:")]), _vm._v(" In Joshua 3, when the children of Israel were to go through the Jordan, at God’s command the ark of the Lord was carried into the middle of the water of the Jordan; and, as it was standing there, it held back the water of the Jordan so that it did not flow over the children of Israel; instead, it allowed them to walk through on dry ground. So also Christ is the true Throne of Grace, in whom the entire fullness of the Godhead resides bodily. He himself stepped into the middle, so that the flood of divine wrath would not suddenly assault us. Instead, by this [action] we may now enter into the promised eternal fatherland. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURTH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDAY OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVENT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-252",
      "id": "ap_ntf-252-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-032"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("3:14-17 "), _c('i', [_vm._v("The Crossing Begins")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURAGE OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENDED")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" The valor of the priests in proceeding boldly beyond the bed into the water itself was deserving of no mean praise, since they might have been afraid of being instantly drowned. For what could they expect on putting in their feet, but immediately to find a deep pool in which they would be engulfed? In not being afraid on reaching the stream, and in continuing to move firmly forward to the appointed place, they give a specimen of rare alacrity, founded on confidence. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:15")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-253",
      "id": "ap_ntf-253-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGER OF THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVER")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAN")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMAL")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" To the general danger was added the special one, that the Jordan had then overflowed its banks. . . . As the plain was covered, it was impossible to observe the line of the banks or the ford, and the slime spread far and wide increased their fear and anxiety. God was pleased that his people, and especially the priests, should contend with these obstacles, in order that the victory of their faith and constancy might be more illustrious. At the same time, the difficulty thus presented tended to magnify the glory of the miracle when the waters, which had overflown their banks, retired at the divine command, and were gathered together into a solid heap. First, Joshua explains the nature of the miracle for the purpose of removing doubt, and preventing profane people from denying the divine interposition by a subtle searching for other causes. It is not, indeed, impossible that the flowing of the water might have been restrained for a short time, and that some portion of the channel might thus have appeared dry, or that the course might have changed and taken some other direction. But it was certainly neither a natural nor accidental event, when the waters stood gathered up into a heap. It is therefore said that the waters that previously flowed from the higher ground, seeking in their descent a continuous outlet, stood still. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:15")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-254",
      "id": "ap_ntf-254-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANT BY THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDST OF THE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN?")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" This "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("statement is not meant of the midway point of the river, or the middle part, as appears by the reasons before given at verse 8, but of the channel near the bank on the other side. Neither does (as learned interpreters observe) the Hebrew word here used, and translated “midst” usually and properly signify the middle part of a thing, or that which stands in the midway, as that which is within a thing itself, or contained within the verge or circumference of it, whether it be in the middle or in the outside and extreme part of it. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-255",
      "id": "ap_ntf-255-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFUL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIALS WITH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" There is full comfort in knowing that during the entire time when the ark of the covenant stood in the middle of the shallows of the Jordan, that heap of waters was held back by a lofty display of divine power. For we noted above that the ark signifies Christ, and the waters are the many afflictions we face. There can be no doubt that many people grew pale and trembled when they turned their eyes on that stunning wall of water that threatened immediate destruction, and as they scanned the opposite shore and the surrounding area to see whether some enemy army would appear. But because they had Christ present with them, they emerged from all hardships and dangers safe and sound. Today terrible storms often seem as though they will swamp the whole church. But because Christ is in her midst, he does not allow the righteous to be drowned. The prince of this world has his false apostles and his tyrants who sometimes try to do that. But Christ who is in the midst of these dangers, no, more than that, who is present with us in death itself, will not allow them to go beyond their prescribed limit. So then, let us not despair though frightened by the flood of evils. But let us recite Psalm 23 with David from our whole heart. The Lord is the strength of my life, of whom shall I be afraid? The Lord is my light and my salvation, whom shall I fear? While the Lord stands beside me, I will not fear what humans can do to me. There are many public and private instances of the preservation of the righteous. But just as Joshua, the priests, and the people did nothing except according to God’s express command, so also let us continually keep God’s Word in plain sight. If we do that, there are no dangers that confront us, no matter how great, which will keep us from being led to the gate of everlasting happiness. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 16 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:14-17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-256",
      "id": "ap_ntf-256-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOPPOSED?")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" [They met] with no enemies to oppose them and hinder their landing, though it is usual for people in similar cases to guard and man their coasts and frontiers when they are ready to be invaded. This the Canaanites neglected at this time, either because they thought it needless, as being in their view that it was an impossible thing to pass over Jordan at this time when the waters were so high that they overflowed the banks, or because God had given them to folly and deprived them of the use of their reason, so that they never thought of any means of defense, or finally because they were so wholly possessed with terror and bewildering fear that they dared not come out into the open field, but kept themselves barricaded in their strong, fenced, and high-walled city. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-257",
      "id": "ap_ntf-257-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING OF THE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NALOGOUS TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTISM")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER:")]), _vm._v(" The sacrament is for us a ford, a bridge, a door, a ship, and a litter, in which and by which we pass from this world into eternal life. Therefore all depends on faith. The one who does not believe is like one who must cross the sea, but is so timid that they do not trust the ship; and so they must remain and never be saved, because they do not embark and cross over. This is due to our dependence on the senses and to our untried faith that shrinks from the passage across the Jordan of death—the devil also cruelly helps toward this.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_vm._v("This was indicated of old in Joshua 3. After the children of Israel had gone dry-shod through the Red Sea, a type of baptism, they went through the Jordan in like manner; but the priests stood with the ark in Jordan, and the water below them flowed by, while that above them stood on a heap, a type of this sacrament. The priests carry and uphold the ark in Jordan when in the hour of our death or peril they preach and administer to us this sacrament, Christ, and the fellowship of all saints. If we believe, the waters below us depart; that is, the temporal, visible things harm us not, but flee from us. And those above us stand up high, as though they would overwhelm us; these are the horrors and apparitions of the other world, which at the hour of our death terrify us. If, however, we pay no heed to them, and pass on with a firm faith, we shall enter into eternal life dry-shod and unharmed. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATISE ON THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSED")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACRAMENT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-258",
      "id": "ap_ntf-258-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPRESENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDAN FOR")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" We see as well that the crossing of the Jordan is a type of baptism. For Paul in 1 Corinthians 10 says that the Israelites were baptized in the cloud and in the sea, and so the same idea can also apply to them here. For the Israelites were also drowned in death, and emerged unto life. In Romans 6 Paul writes that we have been baptized into the death of Christ and buried with Christ through baptism into his death. We are made partakers in his resurrection. Christ crossed the Jordan; that is, when he underwent the torture of the cross on our behalf, he conquered death, sin, and the devil to make a way across the Jordan for us as well. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 16 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:14-17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-259",
      "id": "ap_ntf-259-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RK OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S AS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRK")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPS:")]), _vm._v(" The priests stand in the midst of the Jordan with the ark of God. They comfort us with the sanctuary . . . that is, with the Lord’s Word, for that is our comfort and the strength of our life in the midst of death until we come out of this world . . . and cross over into the heavenly country, into the blessed rest where we shall rest with God from all our labors, work, and cares in eternity. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCHIRIDION")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-260",
      "id": "ap_ntf-260-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURATIVE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANINGS IN THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" It is thought by some that the place thus made dry for the people to pass over was where Bethabara"), _c('sup', [_vm._v("†")]), _vm._v(" afterward stood, signifying the house of passage, in which place John was baptizing when Jesus came to him. An allegory is to be understood in the transition from the cloud (now vanished), which in the time of Moses was set to guide the people in their way, and its replacement by the ark that now goes before them: this sets forth for us that in the time of the law all things were obscure, but under the gospel (when Jesus came) they were made clear, to be beheld with open face. A moral interpretation teaches us that while we live here, we are as it were under a cloud, and see but darkly, in comparison what we shall do after death, for then we shall see face-to-face. And as the ark went into the Jordan before them, so Jesus goes before us in baptism and in death, so that we might not fear. Again, as they were bidden to look at the ark and follow it, so we must not look at the examples of humans, for they may err, but only at Christ his Word, our most sure direction. And therefore as the ark was so placed that all might see it, and not those in front only, so the Word must be handled, that all may understand it. Last, as for reverence to the ark all kept far off from it, so Christ and his Word must be reverenced; neither may we pry into his mysteries beyond all bounds. God’s saying to Joshua, “this day I will magnify you,” anticipates his magnifying Jesus, when he went into Jordan to be baptized, by the voice coming from heaven and the Spirit descending on him, after which he was also magnified by many miracles. The priests going before and bearing the ark, which had three things "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("in it (the Testament, the pot of manna, and Aaron’s rod), figuratively taught that ministers should go before the people in teaching the law, in administering the bread of life, and in directing them through the holiness of their own lives. Last, the people’s passing through water into Canaan is for us a figure of the afflictions through which the faithful must pass into the heavenly Canaan, especially when they are nearest the entrance and seeing the huge floods of temptations ready to overwhelm them; but as they looked to the ark, so we must especially fix our eyes on the ark of Christ by faith, and so we (like they were) shall be preserved. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-261",
      "id": "ap_ntf-261-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION IN THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACE OF THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREAT OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" There can be no doubt that this wonderful sight must have been received with feelings of fear, leading the Israelites more distinctly to the knowledge that they were saved in the midst of death. For what was that collected heap of waters but a grave in which the whole multitude would have been buried, had the waters resumed their naturally liquid state? Had they walked on the waters their faith might have served them as a kind of bridge. But now, while mountains of water hung over their heads, it is just as if they had found an open and level path between them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-262",
      "id": "ap_ntf-262-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MAGE OF THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRY INTO THE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGDOM OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVEN")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOVANNI")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IODATI:")]), _vm._v(" This second passage through the waters of the Jordan dried up by a miracle, as were the waters of the Red Sea, was a figure of the faithful believer’s last passage into the kingdom of heaven through corporal death, in which Jesus Christ is figured by the ark, which causes them to pass without any danger or loss, cutting off the course and natural sequel, which is from life to eternal death. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-263",
      "id": "ap_ntf-263-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMOVES")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BSTACLES TO THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WN")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" Allegorically, we also conclude that God removes from the righteous all those obstacles that seem able to deny them eternal salvation. For the one who makes his path through the depth of the sea, where will he not make a way? The great power of the waters, namely, afflictions, seems to draw them back, but God leads his church through the enormous hardships of this road, and through the very heart of death to the Promised Land, that is, everlasting life. There is no possible way that afflictions, heresies, and other things of this sort can keep the righteous from everlasting life. No, these seem rather to drive the righteous toward it. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 16 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 3:14-17")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-264",
      "id": "ap_ntf-264-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  })])])]), _c('section', {
    staticClass: "defnotes",
    attrs: {
      "epub:type": "footnotes"
    }
  }, [_c('aside', {
    staticClass: "ntb",
    attrs: {
      "epub:type": "footnote",
      "id": "ntb-006"
    }
  }, [_c('p', {
    staticClass: "txt_ssalinea"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap7#ap_ntb-006-1"
    }
  }, [_vm._v("a")]), _vm._v(". A cubit was about 18 inches or 45 centimeters   ")])]), _c('aside', {
    staticClass: "ntb",
    attrs: {
      "epub:type": "footnote",
      "id": "ntb-007"
    }
  }, [_c('p', {
    staticClass: "txt_ssalinea"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap7#ap_ntb-007-1"
    }
  }, [_vm._v("b")]), _vm._v(". Hebrew "), _c('i', [_vm._v("the ark of the covenant, the Lord of all the earth")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091d3380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap7.vue
// module id = 102
// module chunks = 0